import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=13a8ae50&scoped=true"
import script from "./Tester.vue?vue&type=script&lang=js"
export * from "./Tester.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8ae50",
  null
  
)

export default component.exports